<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('teams') }} </h3>
        <span></span>
    </div>

    <div class="card-component">
        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="10"
            [pageable]="true" [sortable]="true" [groupable]="true" [reorderable]="true" [resizable]="true"
            [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 230px;" (valueChange)="onFilter($event)">
                </kendo-textbox>
                <kendo-grid-spacer></kendo-grid-spacer>
                <button [hidden]="!canEdit()" kendoButton icon="add" [title]="customMsgService.translate('btnCriar')"
                    (click)="open()" themeColor="primary">

                </button>

                <button kendoGridExcelCommand type="button" icon="file-excel"
                    [title]="customMsgService.translate('btnExportarExcel')" themeColor="warning">
                </button>

                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> 
                </button>
            </ng-template>

            <kendo-grid-column field="nome" [title]="customMsgService.translate('name')" [width]="220">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.nome }} </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="nomeLocal" [width]="210" [title]="customMsgService.translate('local')"> </kendo-grid-column>

            <kendo-grid-column field="numeroDeFuncionarios" [width]="220" [title]="customMsgService.translate('numeroDeFuncionarios')"> </kendo-grid-column>


            <kendo-grid-column field="supervisoresDescricao" [width]="210" [title]="customMsgService.translate('supervisores')">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.supervisores.join(', ') }}</div>
                </ng-template> </kendo-grid-column>

            <kendo-grid-column title="" [width]="50" [hidden]="!canEditTeamsFormTools()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="wrench"
                        [title]="customMsgService.translate('btnFerramentasAutorizadas')"
                        (click)="openTiposFerramentas(dataItem)" [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="50" [hidden]="!canEditTeamsFormIV()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="cart"
                        [title]="customMsgService.translate('btnArtigosAutorizados')"
                        (click)="openArtigos(dataItem)" [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="50" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="pencil" [title]="customMsgService.translate('btnEditar')"
                        (click)="openEdit(dataItem)" [primary]="true"></button>

                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="50" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="delete" [title]="customMsgService.translate('btnEliminar')"
                        (click)="delete(dataItem)" themeColor="error"></button>

                </ng-template>
            </kendo-grid-column>
            <kendo-grid-pdf fileName="{{customMsgService.translate('teams')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('teams') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>

                <kendo-grid-column field="nome" [title]="customMsgService.translate('name')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeLocal" [title]="customMsgService.translate('local')"> </kendo-grid-column>
                <kendo-grid-column field="numeroDeFuncionarios"
                    [title]="customMsgService.translate('numeroDeFuncionarios')"> </kendo-grid-column>

                <kendo-grid-column field="supervisoresDescricao" [title]="customMsgService.translate('supervisores')">
                </kendo-grid-column>

            </kendo-grid-pdf>

            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('teams')}}.xlsx">
            </kendo-grid-excel>

        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>